<template>
  <section v-on:click="headerClicked">
    <div class="menu-cnt" :class="{open: menuOpen}">
      <div class="menu-bg"></div>
      <div class="menu-close" v-on:click="toggleMenu">
        <div class="line l1"></div>
        <div class="line l2"></div>
        <div class="line l3"></div>
      </div>
      <div class="menu-content">
        <li v-for="(m, i) in menu" :key="`m${i}`"
          :class="{hasDd: m.submenus && m.submenus.length > 0,
          hidden: m.status === 'unpublished', submenuOpen: m.submenuOpen}">
          <div class="menuItem" v-if="m.type === 'Unclickable'">
            <span>{{m.name[lang]}}</span>
            <div class="ddIcon"></div>
          </div>
          <a :href="m.link" class="menuItem green" v-else-if="m.type === 'External Link'"
            v-on:click.prevent="openMenuItem($event, m)">
            <span>{{m.name[lang]}}</span>
            <div class="ddIcon"></div>
          </a>
          <a :href="`${$config.appPath}${langCode}${m.uri}`" class="menuItem" v-else
            v-on:click.prevent="openMenuItem($event, m)">
            <span>{{m.name[lang]}}</span>
            <div class="ddIcon"></div>
          </a>
          <div class="menuDd" v-if="m.submenus && m.submenus.length > 0"
            v-on:mouseleave="liLeave(m)">
            <div class="submenu" v-for="(sm, i2) in m.submenus" :key="`sm${i2}`"
              :class="{hidden: sm.status === 'unpublished'}">
              <div class="submenuTitle">{{sm.title[lang]}}</div>
              <div class="submenuItemWrapper" v-for="(smm, i) in sm.menus" :key="`hmn${i}`">
                <div class="submenuItem" v-if="smm.type === 'Unclickable'"
                  :class="{hidden: smm.status === 'unpublished'}">{{smm.name[lang]}}</div>
                <a class="submenuItem" :href="smm.uri" v-else-if="smm.type === 'External Link'"
                  :class="{hidden: smm.status === 'unpublished'}"
                  v-on:click.prevent="openMenuItem($event, smm)">
                  <span>{{smm.name[lang]}}</span></a>
                <a class="submenuItem" v-else
                  :href="`${$config.appPath}${langCode}${smm.uri}`"
                  :class="{hidden: smm.status === 'unpublished'}"
                  v-on:click.prevent="openMenuItem($event, smm)">
                  <span>{{smm.name[lang]}}</span></a>
                <div class="submenuDd" v-if="smm.submenus && smm.submenus.length > 0"
                  :class="{hidden: smm.status === 'unpublished'}">
                  <div class="submenu" v-for="(sm3, i3) in smm.submenus" :key="`sm${i3}`"
                    :class="{hidden: sm3.status === 'unpublished'}">
                    <div class="submenuTitle">{{sm3.title[lang]}}</div>
                    <div class="submenuItemWrapper"
                      v-for="(smm3, i3a) in sm3.menus" :key="`hmn${i3a}`">
                      <div class="submenuItem" v-if="smm3.type === 'Unclickable'"
                        :class="{hidden: smm3.status === 'unpublished'}">{{smm3.name[lang]}}</div>
                      <a class="submenuItem" :href="smm3.uri"
                        v-else-if="smm3.type === 'External Link'"
                        :class="{hidden: smm3.status === 'unpublished'}"
                        v-on:click.prevent="openMenuItem($event, smm3)">
                        {{smm3.name[lang]}}</a>
                      <a class="submenuItem" v-else
                        :href="`${$config.appPath}${langCode}${smm3.uri}`"
                        :class="{hidden: smm3.status === 'unpublished'}"
                        v-on:click.prevent="openMenuItem($event, smm3)">
                        {{smm3.name[lang]}}</a>
                      <div class="submenuDd" v-if="smm3.submenus && smm3.submenus.length > 0"
                        :class="{hidden: smm3.status === 'unpublished'}">
                        <div class="submenu" v-for="(sm4, i4) in smm3.submenus" :key="`sm${i4}`"
                          :class="{hidden: sm4.status === 'unpublished'}">
                          <div class="submenuTitle">{{sm4.title[lang]}}</div>
                          <div class="submenuItemWrapper"
                            v-for="(smm4, i4a) in sm4.menus" :key="`hmn${i4a}`">
                            <div class="submenuItem" v-if="smm4.type === 'Unclickable'"
                              :class="{hidden: smm4.status === 'unpublished'}">{{smm4.name[lang]}}</div>
                            <a class="submenuItem" :href="smm4.uri"
                              v-else-if="smm4.type === 'External Link'"
                              :class="{hidden: smm4.status === 'unpublished'}"
                              v-on:click.prevent="openMenuItem($event, smm4)">
                              {{smm4.name[lang]}}</a>
                            <a class="submenuItem" v-else
                              :href="`${$config.appPath}${langCode}${smm4.uri}`"
                              :class="{hidden: smm4.status === 'unpublished'}"
                              v-on:click.prevent="openMenuItem($event, smm4)">
                              {{smm4.name[lang]}}</a>
                            <div class="submenuDd" v-if="smm4.submenus && smm4.submenus.length > 0"
                              :class="{hidden: smm4.status === 'unpublished'}">
                              <div class="submenu" v-for="(sm5, i5) in smm4.submenus"
                                :key="`sm${i5}`"
                                :class="{hidden: sm5.status === 'unpublished'}">
                                <div class="submenuTitle">{{sm5.title[lang]}}</div>
                                <div class="submenuItemWrapper"
                                  v-for="(smm5, i5a) in sm5.menus" :key="`hmn${i5a}`">
                                  <div class="submenuItem" v-if="smm5.type === 'Unclickable'"
                                    :class="{hidden: smm5.status === 'unpublished'}">{{smm5.name[lang]}}</div>
                                  <a class="submenuItem" :href="smm5.uri"
                                    v-else-if="smm5.type === 'External Link'"
                                    :class="{hidden: smm5.status === 'unpublished'}"
                                    v-on:click.prevent="openMenuItem($event, smm5)">
                                    {{smm5.name[lang]}}</a>
                                  <a class="submenuItem" v-else
                                    :href="`${$config.appPath}${langCode}${smm5.uri}`"
                                    :class="{hidden: smm5.status === 'unpublished'}"
                                    v-on:click.prevent="openMenuItem($event, smm5)">
                                    {{smm5.name[lang]}}</a>
                                  <div class="submenuDd" v-if="smm5.submenus && smm5.submenus.length > 0"
                                    :class="{hidden: smm5.status === 'unpublished'}">
                                    <div class="submenu" v-for="(sm6, i6) in smm5.submenus"
                                      :key="`sm${i6}`"
                                      :class="{hidden: sm6.status === 'unpublished'}">
                                      <div class="submenuTitle">{{sm6.title[lang]}}</div>
                                      <div class="submenuItemWrapper"
                                        v-for="(smm6, i6a) in sm6.menus" :key="`hmn${i6a}`">
                                        <div class="submenuItem" v-if="smm6.type === 'Unclickable'"
                                          :class="{hidden: smm6.status === 'unpublished'}">{{smm6.name[lang]}}</div>
                                        <a class="submenuItem" :href="smm6.uri"
                                          v-else-if="smm6.type === 'External Link'"
                                          :class="{hidden: smm6.status === 'unpublished'}"
                                          v-on:click.prevent="openMenuItem($event, smm6)">
                                          {{smm6.name[lang]}}</a>
                                        <a class="submenuItem" v-else
                                          :href="`${$config.appPath}${langCode}${smm6.uri}`"
                                          :class="{hidden: smm6.status === 'unpublished'}"
                                          v-on:click.prevent="openMenuItem($event, smm6)">
                                          {{smm6.name[lang]}}</a>
                                        <div class="submenuDd" v-if="smm6.submenus && smm6.submenus.length > 0"
                                          :class="{hidden: smm6.status === 'unpublished'}">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </div>
    </div>
    <header class="header">
      <a :href="`${$config.appPath}${langCode}`" class="header-logo"></a>
      <div class="header-l">
        <div class="search">
          <input type="text" name="search" :placeholder="(lang === 'id' ? 'Cari...' : 'Search...')">
          <div class="search-icon"></div>
        </div>
      </div>
      <div class="header-r">
        <div class="cta">
          Lakukan Sesuatu
        </div>
        <div class="language">
          <div class="lang-btn" :class="lang"
            v-on:click.stop="showLangSelector = true">
            <template v-if="lang === 'id'">
              <span class="lang-name">Bahasa Indonesia</span>
              <span class="lang-code">ID</span>
            </template>
            <template v-if="lang === 'en'">
              <span class="lang-name">English</span>
              <span class="lang-code">EN</span>
            </template>
          </div>
          <div class="lang-selector" v-if="showLangSelector"
            v-on:click.stop="doNothing">
            <div class="lang-item" v-on:click.stop="selectLang('en')">
              English
            </div>
            <div class="lang-item id" v-on:click.stop="selectLang('id')">
              Bahasa Indonesia
            </div>
          </div>
        </div>
        <div class="sound" v-on:click="$emit('toggleAudio')" :class="{muted: audioMuted}"></div>
        <div class="menu" v-on:click="toggleMenu">
          <div class="line l1"></div>
          <div class="line l2"></div>
          <div class="line l3"></div>
        </div>
      </div>
    </header>
  </section>
</template>

<script>
const nanoid = require('nanoid');

export default {
  components: {},
  props: ['audioMuted'],
  data() {
    return {
      logo: null,
      menu: [],
      menuOpen: false,


      /**
       * Language
       *
       */
      lang: 'id',
      langCode: 'id-id',
      showLangSelector: false,
    };
  },
  methods: {
    doNothing() {},
    openMenuItem(e, m) {
      let session = localStorage.getItem('bye_ua_session');
      if (!session) {
        session = nanoid.nanoid(64);
        localStorage.setItem('bye_ua_session', session);
      }
      this.$http.get(this.$config.uri(`config/menu/${m.code}/analytic?session=${session}`));
      if (m.type === 'External Link') {
        if (!m.link) return;
        setTimeout(() => {
          window.location.href = m.link;
        });
      } else {
        if (!m.uri) return;
        const uri = `${this.$config.appPath}${this.langCode}${m.uri}`;
        setTimeout(() => {
          window.location.href = uri;
        });
      }
    },
    selectLang(lang) {
      this.lang = lang;
      this.showLangSelector = false;
      const langCode = lang === 'id' ? 'id-id' : 'en-us';
      const fullPath = this.$route.fullPath.replace(/\/[a-z]+-[a-z]+\/?/, `/${langCode}/`);
      window.location.href = fullPath;
    },
    headerClicked() {
      this.showLangSelector = false;
      // this.searchOpenLg = false;
      // this.viewSearchDd = false;
      // document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      // if (this.menuOpen) this.toggleMenu();
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen) {
        document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
      } else {
        document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      }
    },
    selectSearch(item) {
      // if (item.title && (!item.url || item.url === '')) return;
      // if (item.title) {
      //   window.open(item.url, '_blank').focus();
      // } else {
      //   // this.$router.push('/team-up-everyday');
      // }
    },
    openSearch() {
      // this.searchOpen = true;
      // setTimeout(() => {
      //   this.$refs.search.focus();
      // }, 300);
    },
    searchFocused() {
      // this.searchOpenLg = true;
      // this.search();
    },
    gotoSearch() {
      // if (this.$refs.search) this.$refs.search.focus();
      // if (!this.q || this.q === '') return;
      // window.location.href = `${this.$config.appPath}${this.langCode}/search?q=${this.q}`;
    },
    search() {
      // clearTimeout(this.searchTimer);
      // this.searchTimer = setTimeout(() => {
      //   if (!this.q || this.q === '') {
      //     this.searchLoading = false;
      //     this.viewSearchDd = false;
      //     document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      //     return;
      //   }
      //   this.searchLoading = true;
      //   this.$http.post(this.$config.uri('misc/search'), {
      //     q: this.q,
      //     lang: this.lang,
      //   }).then((r) => {
      //     this.searchResults = (r.data.status === 200) ? r.data.data : [];
      //     this.searchLoading = false;
      //     this.viewSearchDd = true;
      //     document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
      //   });
      // }, 500);
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    this.$http.get(this.$config.uri('config/item/logo?media=y')).then((r) => {
      this.logo = (r.data.status === 200) ? r.data.data : null;
    });

    this.$http.get(this.$config.uri('config/menu')).then((r) => {
      this.loadingMenu = false;
      this.menu = (r.data.status === 200) ? r.data.data : [];
    });

    if (this.$route.name === 'search') this.q = this.$route.query.q;
  },
};
</script>

<style scoped lang="scss">
.menu-cnt{
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  overflow: auto;
  z-index: 99999;
  opacity: 0;
  visibility: hidden;
  transition: all .3s ease;
  .menu-bg{
    position: fixed;
    width: 100%; height: 100%;
    left: 0; top: 0;
    &:before{
      position: absolute;
      content: "";
      left: 50%; top: 0; right: 0; bottom: 0;
      left: 0; top: 0; bottom: 0; right: 50%;
      background-image: linear-gradient(to right, rgba(255, 204, 0, .67), #FFCC00);
    }
    &:after{
      position: absolute;
      content: "";
      left: 50%; top: 0; right: 0; bottom: 0;
      background-color: #FFCC00;
    }
  }
  .menu-close{
    width: 44px;
    height: 44px;
    border-radius: 50%;
    cursor: pointer;
    position: fixed;
    top: 26px; right: 40px;
    transition: all .3s ease;
    z-index: 7;
    @media (max-width: 840px) {
      top: 12px; right: 22px;
    }
    .line{
      width: 30px;
      height: 2px;
      background-color: #444;
      position: absolute;
      top: 50%; left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      transition: all .7s ease;
      &.l1{
        margin-top: -8px;
      }
      &.l3{
        margin-top: 8px;
      }
    }
    &:hover{
      background-color: rgba(0, 0, 0, .1);
    }
  }
  .menu-content{
    position: absolute;
    z-index: 3;
    right: 0; top: 0; bottom: 0; left: 50%;
    box-sizing: border-box;
    padding: 60px 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (max-width: 1480px) {
      max-height: 680px;
    }
    @media (max-width: 1200px) {
      left: 40%;
    }
    @media (max-width: 680px) {
      left: 0;
    }
    li{
      list-style: none;
      font-size: 46px;
      font-family: 'Bebas Neue', sans-serif;
      color: #444;
      text-align: center;
      @media (max-width: 1480px) {
        font-size: 36px;
      }
      .menuItem{
        color: #444;
        position: relative;
        span{
          position: relative;
          z-index: 3;
        }
      }
      a.menuItem{
        &:before{
          content: "";
          position: absolute;
          top: 50%; left: 50%;
          transform: translate(-50%, -50%);
          width: 0; height: 100%;
          background-image: url(../assets/hover-bg-orange.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          transition: all .2s ease;
          opacity: 0;
        }
        &:hover{
          &:before{
            width: 130%;
            opacity: 1;
          }
        }
      }
      .submenuItem{
        color: #444;
        position: relative;
        span{
          position: relative;
          z-index: 3;
        }
        &:before{
          content: "";
          position: absolute;
          top: 50%; left: 50%;
          transform: translate(-50%, -50%);
          width: 0; height: 99%;
          background-image: url(../assets/hover-bg-orange.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          transition: all .2s ease;
          opacity: 0;
        }
        &:hover{
          &:before{
            width: 130%;
            opacity: 1;
          }
        }
      }
      .menuDd{
        .submenu{
          .submenuTitle{
            display: none;
          }
          .submenuItemWrapper{
            font-size: 26px;
            @media (max-width: 1480px) {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
  &.open{
    opacity: 1;
    visibility: visible;
    .menu-close{
      .line.l1{
        transform: translate(-14px, 8px) rotate(-45deg);
      }
      .line.l2{
        opacity: 0;
      }
      .line.l3{
        transform: translate(-14px, -7px) rotate(45deg);
      }
    }
  }
}
.header-logo{
  position: fixed;
  left: 50%;
  background-image: url(../assets/bye-logo-no-shadow.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 99;
  width: 74px; height: 74px;
  top: 10px;
  margin: 0;
  transform: translateX(-50%);
  display: none;
  @media (max-width: 980px) {
    transform: none;
    left: 40px;
  }
  @media (max-width: 840px) {
    left: 16px;
    width: 56px; height: 56px; top: 8px;
  }
}
header.header{
  position: fixed;
  left: 0; right: 0; top: 0;
  padding: 24px 40px;
  display: flex;
  align-items: center;
  z-index: 99;
  opacity: 0;
  transition: all 1.2s ease;
  @media (max-width: 840px) {
    padding: 14px 20px;
  }
  .header-l{
    margin-right: auto;
    display: flex;
    align-items: center;
    @media (max-width: 980px) {
      display: none;
    }
    .search, .sound{
      margin-right: 20px;
    }
    .search{
      position: relative;
      input{
        font-size: 20px;
        border: #fff 1px solid;
        background: none;
        border-radius: 50px;
        color: #fff;
        font-size: 17px;
        padding: 10px 20px;
        padding-left: 48px;
        box-sizing: border-box;
        width: 340px;
        position: relative;
        z-index: 3;
        outline: none;
        transition: all .3s ease;
        &:hover{
          border-color: #999;
          box-shadow: 0 0 0 1px #999;
        }
        &:focus{
          border-color: #FF9100;
          box-shadow: 0 0 0 1px #FF9100;
          background-color: rgba(0, 0, 0, .6);
        }
      }
      .search-icon{
        position: absolute;
        left: 16px; top: 0; bottom: 0;
        width: 20px;
        background-image: url(../assets/search-white.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 7;
      }
    }
    .sound{
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background-image: url(../assets/audio-on-white.png);
      background-size: 24px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &.muted{
        background-image: url(../assets/audio-off-white.png);
      }
      &:hover{
        background-color: rgba(0, 0, 0, .2);
      }
    }
  }
  .header-r{
    margin-left: auto;
    display: flex;
    align-items: center;
    .language, .cta, .menu, .sound{
      margin-left: 20px;
    }
    .language{
      position: relative;
      .lang-btn{
        font-family: 'Bebas Neue', sans-serif;
        color: #fff;
        border-radius: 3px;
        border: #fff 1px solid;
        padding: 7px 18px 5px;
        padding-left: 60px;
        font-size: 18px;
        letter-spacing: 1px;
        cursor: pointer;
        transition: all .3s ease;
        background-color: rgba(0, 0, 0, .3);
        &:hover{
          background-color: rgba(0, 0, 0, .76);
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
        }
        &:before{
          content: "";
          position: absolute;
          left: 16px; top: 0; bottom: 0;
          width: 30px;
          background-image: url(../assets/lang-us.png);
          background-size: 30px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        .lang-name{
          @media (max-width: 640px) {
            display: none;
          }
        }
        .lang-code{
          display: none;
          @media (max-width: 640px) {
            display: inline-block;
          }
        }
        &.id{
          &:before{
            background-image: url(../assets/lang-id.png);
          }
        }
      }
      .lang-selector{
        position: absolute;
        background-color: #fff;
        border-radius: 5px;
        padding: 10px 0;
        top: 100%; right: 0;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
        .lang-item{
          white-space: nowrap;
          padding: 8px 24px;
          cursor: pointer;
          transition: all .3s ease;
          padding-left: 56px;
          position: relative;
          &:hover{
            background-color: #eee;
          }
          &:before{
            content: "";
            position: absolute;
            left: 18px; top: 0; bottom: 0;
            width: 26px;
            background-image: url(../assets/lang-us.png);
            background-size: 30px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &.id{
            &:before{
              background-image: url(../assets/lang-id.png);
            }
          }
        }
      }
    }
    .cta{
      border-radius: 50px;
      background-color: #FF9100;
      padding: 12px 26px 10px;
      letter-spacing: 1px;
      color: #fff;
      font-family: 'Bebas Neue', sans-serif;
      font-size: 20px;
      background-image: linear-gradient(180deg, #FF8B66 0%, #FC0 52.08%, #FF9100 100%);
      color: #000;
      display: none;
    }
    .sound{
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background-image: url(../assets/audio-on-white.png);
      background-size: 24px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &.muted{
        background-image: url(../assets/audio-off-white.png);
      }
      &:hover{
        background-color: rgba(0, 0, 0, .2);
      }
    }
    .menu{
      width: 44px;
      height: 44px;
      border-radius: 50%;
      cursor: pointer;
      position: relative;
      transition: background-color .3s ease;
      .line{
        width: 30px;
        height: 2px;
        background-color: #fff;
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 10px;
        &.l1{
          margin-top: -8px;
        }
        &.l3{
          margin-top: 8px;
        }
      }
      &:hover{
        background-color: rgba(0, 0, 0, .2);
      }
    }
  }
}
.scrolled header.header{
}
.intro header.header{
  opacity: 1;
}
.page-cnt.lakukan-sesuatu-_lakukan-sesuatu-submenu_jika-kamu-seorang-akp-migran-{
   header.header{
    // box-shadow: 0 0 6px rgba(0, 0, 0, .2);
    // background-color: rgba(255, 255, 255, .3);
    backdrop-filter: blur(12px);
    .header-l{
      .search{
        input{
          border-color: #eee;
          background-color: #eee;
          color: #444;
          &:hover{
            border-color: #999;
            box-shadow: 0 0 0 1px #999;
          }
          &:focus{
            border-color: #FF9100;
            box-shadow: 0 0 0 1px #FF9100;
            background-color: #fff;
          }
        }
        .search-icon{
          background-image: url(../assets/search.png);
        }
      }
      .sound{
        background-image: url(../assets/audio-on.png);
        &.muted{
          background-image: url(../assets/audio-off.png);
        }
        &:hover{
          background-color: rgba(0, 0, 0, .2);
        }
      }
    }
    .header-r{
      .language{
        .lang-btn{
          color: #444;
          border-color: #eee;
          background-color: #eee;
          &:hover{
            box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
            border-color: #e5e5e5;
            background-color: #e5e5e5;
          }
        }
      }
      .sound{
        background-image: url(../assets/audio-on.png);
        &.muted{
          background-image: url(../assets/audio-off.png);
        }
        &:hover{
          background-color: rgba(0, 0, 0, .2);
        }
      }
      .menu{
        .line{
          background-color: #444;
        }
        &:hover{
          background-color: rgba(0, 0, 0, .1);
        }
      }
    }
  }
}
.hasBg header.header{
  background-color: #fff !important;
  box-shadow: 0 0 6px rgba(0, 0, 0, .2);
  .header-l{
    .search{
      input{
        border-color: #eee;
        background-color: #eee;
        color: #444;
        &:hover{
          border-color: #999;
          box-shadow: 0 0 0 1px #999;
        }
        &:focus{
          border-color: #FF9100;
          box-shadow: 0 0 0 1px #FF9100;
          background-color: #fff;
        }
      }
      .search-icon{
        background-image: url(../assets/search.png);
      }
    }
    .sound{
      background-image: url(../assets/audio-on.png);
      &.muted{
        background-image: url(../assets/audio-off.png);
      }
      &:hover{
        background-color: rgba(0, 0, 0, .2);
      }
    }
  }
  .header-r{
    .language{
      .lang-btn{
        color: #444;
        border-color: #eee;
        background-color: #eee;
        &:hover{
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
          border-color: #e5e5e5;
          background-color: #e5e5e5;
        }
      }
    }
    .sound{
      background-image: url(../assets/audio-on.png);
      &.muted{
        background-image: url(../assets/audio-off.png);
      }
      &:hover{
        background-color: rgba(0, 0, 0, .2);
      }
    }
    .menu{
      .line{
        background-color: #444;
      }
      &:hover{
        background-color: rgba(0, 0, 0, .1);
      }
    }
  }
}
.page header.header{
  opacity: 1;
  transition: all .4s ease;
  .header-logo{
    display: block;
  }
}
</style>
